import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableColumn } from '@app/models/table';
import { Button } from '../button/button';

@Component({
  selector: 'app-expandable-table',
  standalone: true,
  imports: [CommonModule, Button],
  templateUrl: './expanded-table.html',
  styleUrl: './expanded-table.css',
})
export class ExpandableTableComponent<T extends Record<string, any>> {
  @Input({ required: true }) columns: TableColumn<T>[] = [];
  @Input({ required: true }) data: T[] = [];

  /** template recibido desde el padre */
  @Input() expandedTemplate?: TemplateRef<{ $implicit: T; close: () => void }>;
  @Input() withButton: boolean = true;
  @Input() buttonLabel: string = 'Ver más';
  @Input() expandOnButtonClick: boolean = false;
  @Input() withCheckboxes: boolean = false;
  @Output() buttonClick = new EventEmitter<T>();
  @Output() actionOnSelection = new EventEmitter<T[]>();

  selectedRows = new Set<string>();

  expandedIndex: number | null = null;

  toggle(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  isExpanded(index: number) {
    return this.expandedIndex === index;
  }

  onButtonClick(row: T) {
    this.buttonClick?.emit(row);
    if (this.expandOnButtonClick) {
      const index = this.data.indexOf(row);
      this.toggle(index);
    }
  }

  toggleRow(row: any, checked: boolean) {
    if (checked) {
      this.selectedRows.add(row.id);
    } else {
      this.selectedRows.delete(row.id);
    }
    this.actionOnSelection?.emit(this.getSelectedRows());
  }

  isSelected(row: any): boolean {
    return this.selectedRows.has(row.id);
  }

  allSelected() {
    return this.data.length > 0 && this.selectedRows.size === this.data.length;
  }

  toggleAll(checked: boolean) {
    this.selectedRows.clear();
    if (checked) {
      this.data.forEach((row) => this.selectedRows.add(row['id']));
    }
    this.actionOnSelection?.emit(this.getSelectedRows());
  }

  getSelectedRows(): T[] {
    return this.data.filter((row) => this.selectedRows.has(row['id']));
  }
}
